import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute, GuestRoute } from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import PublicProfile from "./pages/PublicProfile";
import ImageView from "./pages/ImageView";
import PaymentResult from "./pages/PaymentResult";
import DashboardLayout from "./pages/dash/DashboardLayout";
import Overview from "./pages/dash/Overview";
import Customize from "./pages/dash/Customize";
import ImageHost from "./pages/dash/ImageHost";
import Store from "./pages/dash/Store";
import Settings from "./pages/dash/Settings";
import Admin from "./pages/dash/Admin";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
          <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentResult success /></ProtectedRoute>} />
          <Route path="/payment/cancel" element={<ProtectedRoute><PaymentResult /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<Overview />} />
            <Route path="customize" element={<Customize />} />
            <Route path="images" element={<ImageHost />} />
            <Route path="store" element={<Store />} />
            <Route path="settings" element={<Settings />} />
            <Route path="admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
          </Route>
          <Route path="/i/:id" element={<ImageView />} />
          <Route path="/:username" element={<PublicProfile />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0d0d10", border: "1px solid #262630", color: "#f4f4f6" } }} />
    </AuthProvider>
  );
}

export default App;
